import axios from "axios";
import { useEffect, useState } from "react";
import "../../styles/globals.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Scrollbar, Mousewheel } from "swiper";
import "../../components/shared/SwiperCustomComponent/CustomSwiper.scss";
import clsx from "clsx";
// import CustomSwiperItem from "../shared/SwiperCustomComponent/CustomSwiperItem";
import Link from "../shared/Link";
import ThumbGallerySwiper from "../shared/SwiperCustomComponent/ThumbGallerySwiper";
import "./style.scss";
import { replaceItemsLink } from "../../utils/helper";
import scrolldirectionLeft from "../../images/scrolldirectionLeft.svg";
import scrolldirectionRight from "../../images/scrolldirectionRight.svg";
import { ReactSVG } from "react-svg";

const HotProduct = () => {
  const [items, setItems] = useState([]);
  const [itemsLink, setItemsLink] = useState([]);
  const [shouldRender, setShouldRender] = useState(false);
  // console.log(process.env.REACT_APP_API_ENDPOINT);

  // https://devtrium.com/posts/async-functions-useeffect

  //   // declare the async data fetching function
  //   const fetchProducts = async (pageNumber, keywords) => {
  //     setLoading(true);
  //     const res = await axios(`${process.env.REACT_APP_API_ENDPOINT}/products`, {
  //       params: {
  //         pageNumber: pageNumber,
  //         pageSize: pageSize,
  //         keywords: keywords,
  //       },
  //     });
  //     let results = res?.data?.resp_result?.result?.products?.product;
  //     if (results === undefined || results?.length <= 0) {
  //       setLoading(false);
  //       return;
  //     }
  //     setItems((prev) => [...prev, ...results]);
  //     setLoading(false);
  //   };
  const types = [
    "electronics",
    "fish",
    "food",
    "car",
    "dress",
    "jewel",
    "kid",
    "baby",
    "sport",
    "camp",
    "phone",
    "key",
    "cover",
    "watch",
    "lamp",
    "mouse",
    "hat",
    "health",
    "kitchen",
    "Garden",
    "clothes",
    "tools",
    "kit",
    "storage",
    "laptop",
    "computer",
    "tablets",
    "timber",
    "plumber",
    "home",
    "gadget",
    "part",
  ];

  // declare the async data fetching function
  const fetchHotProduct = async () => {
    // console.log("fetchHotProduct");
    const res = await axios(
      // `${process.env.REACT_APP_API_ENDPOINT}/taobao_hotproduct`,
      `${process.env.REACT_APP_API_ENDPOINT}/products`,
      {
        params: {
          // category_ids: ["100006664", "200003500"],
          // category_id: "100006664",
          pageNumber: 1,
          pageSize: 15,
          keywords: types?.[Math.floor(Math.random() * types?.length)],
        },
      }
    );
    let results = res?.data?.resp_result?.result?.products?.product;
    results?.map(async (item) => {
      let link = await replaceItemsLink(item?.promotion_link);
      setItemsLink((prev) => [...prev, link]);
    });

    setItems(results);
  };

  useEffect(() => {
    if (itemsLink?.length > 0) {
      setShouldRender(true);
    }
  }, [itemsLink]);

  useEffect(() => {
    if (items?.length <= 0) {
      // call the function
      fetchHotProduct()?.catch(console.error); // make sure to catch any error
    }
  });

  return (
    shouldRender && (
      <div className="hotProducts">
        <div className="comp-wrap">
          <div className="scroll-note flex-it flex-align-item-center flex-justify-center">
            {/* <img src={scrolldirectionLeft} alt="scroll left" /> */}
            <ReactSVG src={scrolldirectionLeft} />
            <label className="flex-it flex-align-item-center">scroll</label>
            {/* <img src={scrolldirectionRight} alt="scroll right" />  */}
            <ReactSVG src={scrolldirectionRight} />
          </div>
        </div>
        <Swiper
          className={clsx("generic-swiper swiper-generic-style hotProducts")}
          spaceBetween={24}
          slidesPerView={`auto`}
          freeMode={true}
          preventClicks={true}
          preventClicksPropagation={true}
          scrollbar={true}
          mousewheel={true}
          modules={[FreeMode, Scrollbar, Mousewheel]}
        >
          {items?.map((item, index) => {
            const productId = item?.product_id;
            const link = !!itemsLink[index]
              ? itemsLink[index]
              : item?.promotion_link;
            // const image = item?.product_main_image_url;
            const smallThumbs = item?.product_small_image_urls?.string;
            const title = item?.product_title;
            const imageAlt = item?.product_title;
            const category1 = item?.first_level_category_name;
            const cur = item?.app_sale_price_currency;
            const originaPrice = item?.original_price;
            const salePrice = item?.sale_price;
            // const videoUrl = item?.product_video_url;
            return (
              <SwiperSlide key={index}>
                <Link
                  className={clsx(
                    "item swiper-generic-style shadow-animation-hover"
                  )}
                  productId={productId}
                  hasLink={true}
                  link={link}
                >
                  <div className="thumb-image-swiper">
                    <ThumbGallerySwiper
                      smallThumbs={smallThumbs}
                      imageAlt={imageAlt}
                      isImageOnly={true}
                      scrollbar={false}
                      mousewheel={false}
                    />
                  </div>
                  <div className="info">
                    <div className="wrap-info">
                      <h2 className="category">{category1}</h2>
                      <h1 className="title">{title}</h1>
                      <div className="prices-wrap">
                        <div className="price flex-it flex-align-item-center new-price">
                          <div className="original-price">
                            {cur} {salePrice}
                          </div>
                        </div>
                        <div className="price flex-it flex-align-item-center old-price">
                          <strike>
                            {cur} {originaPrice}
                          </strike>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    )
  );
};
export default HotProduct;
